import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries } from '../../../appconfig/Settings';

import { getAllDetails } from '../../../service/ProductService';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { GET_REFRESHER_COURSE_CANDIDATE_LIST } from '../../../config/ApiConstant';
import { RefresherCourseBookedColumns } from '../../../appconfig/DatatableSetting';
import { exportData, formatDateTime } from '../../../appconfig/AppHelper';
import { InputText } from 'primereact/inputtext';
import { commonNameTemplate } from '../../../appconfig/DatatableTemplateSetting';
import Loader from '../../../components/Loadeer/Loader';

export const ViewRefresherCourseCandidates = () => {
    document.title = 'Booked Refresher Candidates | GSPC';

    // Parameters
    const { courseId }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getAllCandidateList();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [bookedCandidatesList, setBookedCandidatesList] = useState<any>([]);
    const [bookedCourseList, setBookedCourseList] = useState<any>({});

    // Get all booked candidates list
    const getAllCandidateList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_REFRESHER_COURSE_CANDIDATE_LIST + '?refresher_course_id=' + atob(courseId));
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setBookedCandidatesList([]);
                    setBookedCourseList({});
                } else {
                    setBookedCandidatesList(DataList?.list);
                    setBookedCourseList(DataList?.details);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setBookedCandidatesList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setBookedCandidatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>

                <Button label="Export" icon="pi pi-file-export" onClick={() => exportCSV()} />
            </>
        );
    };

    // Export CSV
    const exportCSV = () => {
        exportData('Booked_Student_List');
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Online Refresher Course'} pageName={'Booked Slots'} pageTitle={'Booked Slots'} goToPage={true} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <div className="grid">
                            <div className="field col-12 md:col-6  grid flex-column">
                                <div className="field col-12 grid mb-2">
                                    <div className="field col-12 md:col-4 mb-0">
                                        <b>Refresher Course Name</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-7 mb-0">{!window.cn(bookedCourseList?.refresher_course_name) ? bookedCourseList.refresher_course_name : ''}</div>
                                </div>

                                <div className="field col-12 grid mb-2">
                                    <div className="field col-12 md:col-4 mb-0">
                                        <b>College Name</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-7 mb-0">{!window.cn(bookedCourseList?.college) ? bookedCourseList?.college?.orgnameeng : ''}</div>
                                </div>
                                <div className="field col-12 grid  mb-2">
                                    <div className="field col-12 md:col-4 mb-0">
                                        <b>Start Date</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-7 mb-0">{!window.cn(bookedCourseList?.start_date) ? formatDateTime(bookedCourseList?.start_date) : ''}</div>
                                </div>
                                <div className="field col-12 grid  mb-2">
                                    <div className="field col-12 md:col-4 mb-0">
                                        <b>End Date</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-7 mb-0">{!window.cn(bookedCourseList?.end_date) ? formatDateTime(bookedCourseList?.end_date) : ''}</div>
                                </div>
                            </div>
                            <div className="field col-12 md:col-6 grid flex-column align-items-end ">
                                <div className="field col-12 grid mb-2 justify-content-end">
                                    <div className="field col-12 md:col-3 mb-0">
                                        <b>Total Slots</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-2 mb-0">{!window.cn(bookedCourseList?.total_slot) ? bookedCourseList.total_slot : ''}</div>
                                </div>
                                <div className="field col-12 mb-2 grid justify-content-end">
                                    <div className="field col-12 md:col-3 mb-0">
                                        <b>Booked Slots</b>{' '}
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-2 mb-0">{!window.cn(bookedCourseList?.booked_slot) ? bookedCourseList?.booked_slot : ''}</div>
                                </div>
                                <div className="field col-12 grid mb-2 justify-content-end">
                                    <div className="field col-12 md:col-3 mb-0">
                                        <b>Available Slots</b>
                                    </div>
                                    <div className="field col-12 md:col-1 mb-0">:</div>
                                    <div className="field col-12 md:col-2 mb-0">{!window.cn(bookedCourseList?.available_slot) ? bookedCourseList?.available_slot : ''}</div>
                                </div>
                            </div>
                        </div>
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={bookedCandidatesList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={bookedCandidatesList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Candidates Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {RefresherCourseBookedColumns.map((col, i) => {
                                        if (col.field === 'SrNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '9rem' }} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '9rem' }} />;
                                        } else if (col.field === 'present_institute') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'full_name') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                        // else if (col.field === 'BOD') {
                                        //     return <Column key={col.field} field={col.field} header={col.header} body={bodTemplate} />;
                                        // }
                                        else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RefresherCourseBookedColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {!pageLoad && <Loader />}
        </>
    );
};
